import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchWrapper from '../utils/httpClient';
import { API_DIGITAL_PRICE_FETCH_LIST_EXCEL } from '../utils/apis';

export const fetchDigitalPriceListExcel = createAsyncThunk(
  'digitalPriceExcel/fetchList',
  async ({ page = 0, size = 10 }, { rejectWithValue }) => {
    try {
      const response = await fetchWrapper.get(
        `${API_DIGITAL_PRICE_FETCH_LIST_EXCEL}?page=${page}&size=${size}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const digitalPriceExcelSlice = createSlice({
  name: 'digitalPriceExcel',
  initialState: {
    content: [],
    pageNumber: 0,
    totalRecords: 0,
    totalPages: 0,
    loading: false,
    error: null
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDigitalPriceListExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDigitalPriceListExcel.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload.resdata.content;
        state.pageNumber = action.payload.resdata.number; // Now using resdata.number
        state.totalRecords = action.payload.resdata.totalElements; // Using resdata.totalElements
        state.totalPages = action.payload.resdata.totalPages; // Adding totalPages from response
      })
      .addCase(fetchDigitalPriceListExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  }
});

export default digitalPriceExcelSlice.reducer;